import axios from 'axios';
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from "../store";
import Vue from 'vue';

let base = '';
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
//let base = process.env.NODE_ENV=="production"? 'http://api.training.wanghuolou.cn:82':'';
//let base = process.env.NODE_ENV=="production"? 'http://192.168.1.4:5001':'';
//let base = process.env.NODE_ENV=="production"? 'http://192.168.1.4:1004':'';

// 请求延时
axios.defaults.timeout = 60000

var storeTemp = store;
axios.interceptors.request.use(
    config => {
        var curTime = new Date()
        var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))
        // if (storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
        if (storeTemp.state.token) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = "Bearer " + storeTemp.state.token;
        }
        saveRefreshtime();
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.status == 401) {
            var curTime = new Date()
            var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
            // 在用户操作的活跃期内
            if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                return refreshToken({ token: window.localStorage.Token }).then((res) => {
                    if (res.success) {
                        store.commit("saveToken", res.response.token);
                        var curTime = new Date();
                        var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expiresIn));
                        store.commit("saveTokenExpire", expiredate);
                        error.config.__isRetryRequest = true;
                        error.config.headers.Authorization = 'Bearer ' + res.response.token;
                        return axios(error.config);
                    } else {
                        ToLogin()
                        return false;
                    }
                })
                .catch((err) => {
                    ToLogin()
                    return false;
                })
            } else {
                ToLogin()
                return false;
            }
        } else if (response.data.status == 403) {
            Vue.prototype.$message({
                message: '失败！该操作无权限',
                type: 'error'
            });
            return null;
        } else if (response.data.status == 429) {
            Vue.prototype.$message({
                message: '刷新次数过多，请稍事休息重试！',
                type: 'error'
            });
            return null;
        } else if (response.data.status == 500) {
            setTimeout(function () {
                Vue.prototype.$message({
                    message: '服务器错误，请稍后重试！',
                    type: 'error'
                });
            }, 1000)
            return null;
        }
        return response;
    },
    error => {
        // 超时请求处理
        var originalRequest = error.config;
        console.log(error.config)
        if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
            Vue.prototype.$message({
                message: '请求超时！',
                type: 'error'
            });
            originalRequest._retry = true
            return null;
        }
        if (error.response) {
            if (error.response.status == 401) {
                var curTime = new Date()
                var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
                // 在用户操作的活跃期内
                if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                    return refreshToken({ token: window.localStorage.Token }).then((res) => {
                        if (res.success) {
                            // Vue.prototype.$message({
                            //     message: 'refreshToken success! loading data...',
                            //     type: 'success'
                            // });
                            store.commit("saveToken", res.response.token);
                            var curTime = new Date();
                            var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expiresIn));
                            store.commit("saveTokenExpire", expiredate);
                            error.config.__isRetryRequest = true;
                            error.config.headers.Authorization = 'Bearer ' + res.response.token;
                            return axios(error.config);
                        } else {
                            // 刷新token失败 清除token信息并跳转到登录页面
                            ToLogin()
                            return false;   //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
                        }
                    });
                } else {
                    // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
                    ToLogin()
                    return false;   //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
                }
            }
            // 403 无权限
            if (error.response.status == 403) {
                Vue.prototype.$message({
                    message: '失败！该操作无权限',
                    type: 'error'
                });
                return null;
            }
            // 429 ip限流
            if (error.response.status == 429) {
                Vue.prototype.$message({
                    message: '刷新次数过多，请稍事休息重试！',
                    type: 'error'
                });
                return null;
            }
            // 500
            if (error.response.status == 500) {
                setTimeout(function () {
                    Vue.prototype.$message({
                        message: '服务器错误，请稍后重试！',
                        type: 'error'
                    });
                }, 1000)
                return null;
            }
        }
        return ""; // 返回接口返回的错误信息
    }
);
const ToLogin = params => {
    store.commit("saveToken", "");
    store.commit("saveTokenExpire", "");
    store.commit("saveTagsData", "");
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('NavigationBar');
    var routerGo = router.currentRoute.fullPath.substring(0, 6)
    if (routerGo == "/login") {
    } else {
        router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
        });
    }
    // router.replace({
    //     path: "/login",
    //     query: {redirect: router.currentRoute.fullPath}
    // });
    // 调试登录过期后重新登录第一次无法跳转到相应的页面，而是停留在登录页面，所以暂时注释，怀疑重新加载所以看不到console.log("redirect_api--") date:2020-12-23
    window.location.reload()
    return false;  //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
};
export const BaseApiUrl = base;
export const saveRefreshtime = params => {
    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))
    let refreshCount = 1;//滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    } else {
        window.localStorage.refreshtime = new Date(-1);
    }
};

// 系统登录
export const requestLogin = params => {
    return axios.post(`${base}/fftmwebapi/login/login`, params).then(res => res.data);
};

// 获取登录短信验证码
export const getLoginCode = params => {
    return axios.get(`${base}/fftmwebapi/login/getLoginCode`, { params: params }).then(res => res.data);
};

// 短信验证码登录
export const codelogin = params => {
    return axios.get(`${base}/fftmwebapi/login/codelogin`, { params: params }).then(res => res.data);
};

//刷新token
export const refreshToken = params => {
    return axios.get(`${base}/fftmwebapi/login/refreshToken`, { params: params }).then(res => res.data);
};

// ==============================首页接口STAR======================================================================
//首页
//获取报名人数的图表数据
export const examenrollCountGroupByDate = params => {
    return axios.get(`${base}/fftmwebapi/Home/ExamenrollCountGroupByDate`, { params: params });
};
//根据行政区获取报名人数的图表数据
export const examenrollCountGroupByDateByID = params => {
    return axios.get(`${base}/fftmwebapi/Home/ExamenrollCountGroupByDateByID`, { params: params });
};

//获取考试项目报名人数统计
export const examenrollCountGroupByProjectName = params => {
    return axios.get(`${base}/fftmwebapi/Home/ExamenrollCountGroupByProjectName`, { params: params });
};
//根据行政区获取考试项目报名人数统计
export const examenrollCountGroupByProjectNameByID = params => {
    return axios.get(`${base}/fftmwebapi/Home/ExamenrollCountGroupByProjectNameByID`, { params: params });
};

// 社会单位总数及学习中数量
export const getUnitsAndCertificatesResponse = params => {
    return axios.get(`${base}/fftmwebapi/Home/getUnitsAndCertificatesResponse`, { params: params });
};

// 下级社会单位总数及学习中数量
export const getUnitsAndCertificatesResponseByID = params => {
    return axios.get(`${base}/fftmwebapi/Home/getUnitsAndCertificatesResponseByID`, { params: params });
};

// 下级城市/地区的社会单位、持证总数、证书达标数列表
export const getProportionCertificateHolders = params => {
    return axios.get(`${base}/fftmwebapi/Home/GetProportionCertificateHolders`, { params: params });
};

// 下级城市/地区的持证总数统计
export const getProportionCertificateHoldersByID = params => {
    return axios.get(`${base}/fftmwebapi/Home/GetProportionCertificateHoldersByID`, { params: params });
};

// 社会单位持证统计分析
export const getSocialUnitCertificateHoldersStatistics = params => {
    return axios.get(`${base}/fftmwebapi/Home/GetSocialUnitCertificateHoldersStatistics`, { params: params });
};

// 待监管单位
export const getHomeSocialUnitStatistics = params => {
    return axios.get(`${base}/fftmwebapi/Home/GetHomeSocialUnitStatistics`, { params: params });
};

// 地图滑上社会单位，学习中，取证，待监管数量
export const getUnitsAndCertificatesSingleResponseByID = params => {
    return axios.get(`${base}/fftmwebapi/Home/getUnitsAndCertificatesSingleResponseByID`, { params: params });
};

//首页改版新接口
// 共用-获取地图上方滑上浮窗数据
export const getStudentLearnRecords = params => {
    return axios.get(`${base}/fftmwebapi/Home/GetStudentLearnRecords`, { params: params });
};
// 共用-获取地图地标接口
export const getJsonFile = params => {
    return axios.get(`${base}/fftmwebapi/GeoJson/GetJsonFile`, { params: params });
};



//系统管理
//用户管理
export const getUserListPage = params => {
    return axios.get(`${base}/fftmwebapi/userInfo/getUserInfoListPage`, { params: params });
};

// 根据token获取用户详细信息
export const getUserByToken = params => {
    return axios.get(`${base}/fftmwebapi/userInfo/getUserInfoByToken`, { params: params }).then(res => res.data);
};

//新增用户信息
export const addUserInfo = params => {
    return axios.post(`${base}/fftmwebapi/userInfo/addUserInfo`, params);
};

//更新用户信息
export const updateUserInfo = params => {
    return axios.post(`${base}/fftmwebapi/userInfo/updateUserInfo`, params);
};

//删除用户信息
export const deleteUserInfo = params => {
    return axios.delete(`${base}/fftmwebapi/userInfo/deleteUserInfo`, { params });
};

//发送修改密码手机短信验证码
export const sendModifyPasswordSMSVerificationCode = params => {
    return axios.post(`${base}/fftmwebapi/SystemManager/SendModifyPasswordSMSVerificationCode`, params);
};

//修改用户登录密码
export const modifyUserPassword = params => {
    return axios.post(`${base}/fftmwebapi/userInfo/modifyUserPassword`, params);
};

//系统管理
//菜单权限管理

//根据用户ID获取路由树
export const getNavigationBar = params => {
    return axios.get(`${base}/fftmwebapi/menuPermissions/getNavigationBar`, { params: params }).then(res => res.data);
};

//获取菜单树
export const getMenuTree = params => {
    return axios.get(`${base}/fftmwebapi/menuPermissions/getMenuTree`, { params: params });
};

//获取菜单权限树形列表
export const getMenuPermissionsTree = params => {
    return axios.get(`${base}/fftmwebapi/menuPermissions/getMenuPermissionsTree`, { params: params });
};

//新增菜单权限信息
export const addMenuPermissionsInfo = params => {
    return axios.post(`${base}/fftmwebapi/menuPermissions/addMenuPermissionsInfo`, params);
};

//更新菜单权限信息
export const updateMenuPermissionsInfo = params => {
    return axios.post(`${base}/fftmwebapi/menuPermissions/updateMenuPermissionsInfo`, params);
};

//删除菜单权限信息
export const deleteMenuPermissionsInfo = params => {
    return axios.delete(`${base}/fftmwebapi/menuPermissions/deleteMenuPermissionsInfo`, { params: params });
};

//保存菜单权限分配
export const assignMenuPermissions = params => {
    return axios.post(`${base}/fftmwebapi/menuPermissions/assignMenuPermissions`, params);
};

//通过角色获取菜单【无权限】
export const GetAssignMenuPermissionIdByRoleId = params => {
    return axios.get(`${base}/fftmwebapi/menuPermissions/getAssignMenuPermissionIdByRoleId`, { params: params });
};

//系统管理
//角色管理

//根据组织结构ID获取角色信息集合
export const getRoleInfosByOrganizationInfoID = params => {
    return axios.get(`${base}/fftmwebapi/roleInfo/getRoleInfoByName`, { params: params });
};

//获取角色信息分页列表
export const getRoleListPage = params => {
    return axios.get(`${base}/fftmwebapi/roleInfo/getRoleInfoListPage`, { params: params });
};

//新增角色信息
export const addRoleInfo = params => {
    return axios.post(`${base}/fftmwebapi/roleInfo/addRoleInfo`, params);
};

//更新角色信息
export const updateRoleInfo = params => {
    return axios.post(`${base}/fftmwebapi/roleInfo/updateRoleInfo`, params);
};

//删除角色信息
export const deleteRoleInfo = params => {
    return axios.delete(`${base}/fftmwebapi/roleInfo/deleteRoleInfo`, { params: params });
};

//系统管理
// 部门管理

//获取组织结构树
export const getOrganizationTree = params => {
    return axios.get(`${base}/fftmwebapi/departmentInfo/getDepartmentTree`, { params: params });
};

//新增组织结构信息
export const addOrganizationInfo = params => {
    return axios.post(`${base}/fftmwebapi/departmentInfo/addDepartmentInfo`, params);
};

//更新组织结构信息
export const updateOrganizationInfo = params => {
    return axios.post(`${base}/fftmwebapi/departmentInfo/updateDepartmentInfo`, params);
};

//删除组织结构信息
export const deleteOrganizationInfo = params => {
    return axios.delete(`${base}/fftmwebapi/departmentInfo/deleteDepartmentInfo`, { params: params });
};

//系统管理
// 接口管理

//获取接口信息树形列表
export const getApiModulesInfoTree = params => {
    return axios.get(`${base}/fftmwebapi/apiModulesInfo/getApiModulesInfoTree`, { params: params });
};

//获取接口菜单树
export const getApiMenuTree = params => {
    return axios.get(`${base}/fftmwebapi/apiModulesInfo/getApiMenuTree`, { params: params });
};

//新增接口信息
export const addApiModulesInfo = params => {
    return axios.post(`${base}/fftmwebapi/apiModulesInfo/addApiModulesInfo`, params);
};

//更新接口信息
export const updateApiModulesInfo = params => {
    return axios.post(`${base}/fftmwebapi/apiModulesInfo/updateApiModulesInfo`, params);
};

//删除接口信息
export const deleteApiModulesInfo = params => {
    return axios.delete(`${base}/fftmwebapi/apiModulesInfo/deleteApiModulesInfo`, { params: params });
};

//系统管理
// 数据权限管理

//获取全部数据权限信息列表
export const getAllDataPermissionsInfoList = params => {
    return axios.get(`${base}/fftmwebapi/dataPermissionsInfo/getAllDataPermissionsInfoList`, { params: params });
};

//新增数据权限信息
export const addDataPermissionsInfo = params => {
    return axios.post(`${base}/fftmwebapi/dataPermissionsInfo/addDataPermissionsInfo`, params);
};

//更新数据权限信息
export const updateDataPermissionsInfo = params => {
    return axios.post(`${base}/fftmwebapi/dataPermissionsInfo/updateDataPermissionsInfo`, params);
};

//删除数据权限信息
export const deleteDataPermissionsInfo = params => {
    return axios.delete(`${base}/fftmwebapi/dataPermissionsInfo/deleteDataPermissionsInfo`, { params });
};

//保存数据权限分配
export const assignDataPermissions = params => {
    return axios.post(`${base}/fftmwebapi/dataPermissionsInfo/assignDataPermissions`, params);
};

//通过角色ID获取数据权限菜单【无权限】
export const getAssignDataPermissionIdByRoleId = params => {
    return axios.get(`${base}/fftmwebapi/dataPermissionsInfo/getAssignDataPermissionIdByRoleId`, { params: params });
};

//通用设置
//审批流程管理

//获取审批流程信息分页列表
export const getApprovalProcessListPage = params => {
    return axios.get(`${base}/fftmwebapi/CommonSettings/GetApprovalProcessListPage`, { params: params });
};

//新增审批流程
export const addApprovalProcess = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/AddApprovalProcess`, params);
};

//更新审批流程
export const updateApprovalProcess = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/UpdateApprovalProcess`, params);
};

//根据审批流程ID 获取审批流程图
export const getApprovalProcessDiagramByApprovalProcessID = params => {
    return axios.get(`${base}/fftmwebapi/CommonSettings/GetApprovalProcessDiagramByApprovalProcessID`, { params: params });
};

//通用设置
//展示信息

//获取展示信息分页集合
export const getShowInformationListPage = params => {
    return axios.get(`${base}/fftmwebapi/CommonSettings/GetShowInformationListPage`, { params: params });
};

//新增展示信息
export const addShowInformation = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/AddShowInformation`, params);
};

//更新展示信息
export const updateShowInformation = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/UpdateShowInformation`, params);
};

//删除展示信息
export const deleteShowInformation = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/DeleteShowInformation`, params);
};

//顶置/取消顶置展示信息
export const setTopShowInformation = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/SetTopShowInformation`, params);
};

//通用设置
//轮播信息

//获取轮播信息分页集合
export const getCarouselInformationList = params => {
    return axios.get(`${base}/fftmwebapi/CommonSettings/GetCarouselInformationList`, { params: params });
};

//新增轮播信息
export const addCarouselInformation = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/AddCarouselInformation`, params);
};

//更新轮播信息
export const updateCarouselInformation = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/UpdateCarouselInformation`, params);
};

//删除轮播信息
export const deleteCarouselInformation = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/DeleteCarouselInformation`, params);
};
// 省市区
export const getAreaDictionaryListWithCode = params => {
    return axios.get(`${base}/fftmwebapi/areaDictionary/getAreaDictionaryListWithCode`, { params: params });
};

//通用设置
//数据字典信息

//获取数据字典信息列表
export const getDataDictionaryList = params => {
    return axios.get(`${base}/fftmwebapi/dataDictionary/getById`, { params: params });
};

//新增数据字典信息
export const addDataDictionary = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/AddDataDictionary`, params);
};

//更新数据字典信息
export const updateDataDictionary = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/UpdateDataDictionary`, params);
};

//删除数据字典信息
export const deleteDataDictionary = params => {
    return axios.post(`${base}/fftmwebapi/CommonSettings/DeleteDataDictionary`, params);
};
// 根据命名空间获取数据字典
export const getByNamespace = params => {
    return axios.get(`${base}/fftmwebapi/dataDictionary/getByNamespace`, { params: params });
};

//通用设置
//行政区域
//获取行政区信息列表
export const getAreaDictionaryList = params => {
    return axios.get(`${base}/fftmwebapi/areaDictionary/getAreaDictionaryList`, { params: params });
};
//新增行政区信息
export const addAreaDictionary = params => {
    return axios.post(`${base}/fftmwebapi/aidrwebapi/CommonSettings/AddAreaDictionary`, params);
};

//删除行政区信息
export const deleteAreaDictionary = params => {
    return axios.post(`${base}/fftmwebapi/aidrwebapi/CommonSettings/DeleteAreaDictionary`, params);
};

//抓取行政区信息
export const grabAreaDictionary = params => {
    return axios.post(`${base}/fftmwebapi/aidrwebapi/CommonSettings/GrabAreaDictionary`, params);
};

// 新增客户端版本
export const addAppVersion = (req) => {
    return axios.post(`${base}/fftmwebapi/appVersion/addAppVersion`, req, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

// 删除客户端版本
export const deleteAppVersion = (params) => {
    return axios.delete(`${base}/fftmwebapi/appVersion/deleteAppVersion`, { params: params });
}

// 获取客户端版本分页列表
export const getAppVersionList = (params) => {
    return axios.get(`${base}/fftmwebapi/appVersion/getAppVersionList`, { params: params });
}

// 获取客户端版本分页列表
export const updateAppVersion = (params) => {
    return axios.post(`${base}/fftmwebapi/appVersion/updateAppVersion`, params, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}
//鉴定点类型管理

//职业等级方向
export const getOproomProfessionDirList = (params) => {
    return axios.get(`${base}/fftmwebapi/oproomProfessionDir/getOproomProfessionDirList`, { params: params });
}
//添加
export const addOproomProfessionDir = params => {
    return axios.post(`${base}/fftmwebapi/oproomProfessionDir/addOproomProfessionDir`, params);
};
//删除
export const updateOproomProfessionDir = params => {
    return axios.post(`${base}/fftmwebapi/oproomProfessionDir/updateOproomProfessionDir`, params);
};

//职业功能管理
export const getOproomProfessionFuncList = (params) => {
    return axios.get(`${base}/fftmwebapi/oproomProfessionFunc/getOproomProfessionFuncList`, { params: params });
}
//新增职业技能
export const addOproomProfessionFunc = params => {
    return axios.post(`${base}/fftmwebapi/oproomProfessionFunc/addOproomProfessionFunc`, params);
};
//编辑职业技能
export const updateOproomProfessionFunc = params => {
    return axios.post(`${base}/fftmwebapi/oproomProfessionFunc/updateOproomProfessionFunc`, params);
};

//考位类型管理
//获取当前数据列表
export const getExamSeatTypeList = (params) => {
    return axios.get(`${base}/fftmwebapi/opRoom/getExamSeatTypeList`, { params: params });
}
//添加考位类型
export const addExamSeatType = params => {
    return axios.post(`${base}/fftmwebapi/opRoom/addExamSeatType`, params);
};
//编辑
export const updateExamSeatType = params => {
    return axios.post(`${base}/fftmwebapi/opRoom/updateExamSeatType`, params);
};

//考位设置
//获取当前数据列表
export const getExamSeatExtraDurationList = (params) => {
    return axios.get(`${base}/fftmwebapi/opRoom/getExamSeatExtraDurationList`, { params: params });
}
//根据条件获取鉴定点时间
export const getExtraDurationByCondition = (params) => {
    return axios.get(`${base}/fftmwebapi/opRoom/getExtraDurationByCondition`, { params: params });
}
//添加
export const addExamSeatExtraDuration = params => {
    return axios.post(`${base}/fftmwebapi/opRoom/addExamSeatExtraDuration`, params);
};
//编辑
export const updateExamSeatExtraDuration = params => {
    return axios.post(`${base}/fftmwebapi/opRoom/updateExamSeatExtraDuration`, params);
};

//监控考位
//获取当前数据列表
export const getExamSeatUseDetail = (params) => {
    return axios.get(`${base}/fftmwebapi/score/getExamSeatUseDetail`, { params: params });
}
//维护考位 重置按钮
export const resetExamSeat = params => {
    return axios.post(`${base}/fftmwebapi/opRoom/resetExamSeat`, params);
};

//组卷规则管理
//获取当前数据列表
export const getExamPaperCompRulesList = (params) => {
    return axios.get(`${base}/fftmwebapi/examPaperCompRules/getExamPaperCompRulesList`, { params: params });
}
//检查是否存在正在使用的规则
export const checkIsExistUsingRules = (params) => {
    return axios.get(`${base}/fftmwebapi/examPaperCompRules/checkIsExistUsingRules`, { params: params });
}
//根据ID获取组卷规则详情
export const getRulesDetailById = (params) => {
    return axios.get(`${base}/fftmwebapi/examPaperCompRules/getRulesDetailById`, { params: params });
}
//添加
export const addExamPaperCompRules = params => {
    return axios.post(`${base}/fftmwebapi/examPaperCompRules/addExamPaperCompRules`, params);
};
//编辑
export const updateExamPaperCompRules = params => {
    return axios.post(`${base}/fftmwebapi/examPaperCompRules/updateExamPaperCompRules`, params);
};

//题干管理
//获取题干管理分页列表
export const getExamQuestionList = (params) => {
    return axios.get(`${base}/fftmwebapi/examQuestion/getExamQuestionList`, { params: params });
}
//根据鉴定点id获取题干列表
export const getExamQuestionsByPointId = (params) => {
    return axios.get(`${base}/fftmwebapi/examQuestion/getExamQuestionsByPointId`, { params: params });
}
//新增题干
export const addExamQuestions = params => {
    return axios.post(`${base}/fftmwebapi/examQuestion/addExamQuestions`, params);
};
//更新题干
export const updateExamQuestion = params => {
    return axios.post(`${base}/fftmwebapi/examQuestion/updateExamQuestion`, params);
};
//根据职业等级方向id获取鉴定点个数
export const getPointListByProDir = (params) => {
    return axios.get(`${base}/fftmwebapi/examIdentifyPoint/getPointListByDir`, { params: params });
}

//鉴定点管理
//获取当前数据列表
export const getExamIdentifyPointList = (params) => {
    return axios.get(`${base}/fftmwebapi/examIdentifyPoint/getExamIdentifyPointList`, { params: params });
}
//新增
export const addExamIdentifyPoint = params => {
    return axios.post(`${base}/fftmwebapi/examIdentifyPoint/addExamIdentifyPoint`, params);
}
//编辑
export const updateExamIdentifyPoint = params => {
    return axios.post(`${base}/fftmwebapi/examIdentifyPoint/updateExamIdentifyPoint`, params);
}
//根据考位类型获取鉴定点个数
export const getExamPointNumByExamSeatType = (params) => {
    return axios.get(`${base}/fftmwebapi/examIdentifyPoint/getExamPointNumByExamSeatType`, { params: params });
}


//设备管理
//考位管理

//获取考位类型分页列表

//获取考位分页列表
export const getExamSeatList = (params) => {
    return axios.get(`${base}/fftmwebapi/opRoom/getExamSeatList`, { params: params });
}
//新增考位
export const addExamSeat = params => {
    return axios.post(`${base}/fftmwebapi/opRoom/addExamSeat`, params);
}
//编辑
export const updateExamSeat = params => {
    return axios.post(`${base}/fftmwebapi/opRoom/updateExamSeat`, params);
}
//批量生成考位
export const addBatchExamSeat = params => {
    return axios.post(`${base}/fftmwebapi/opRoom/addBatchExamSeat`, params);
}

//考试模式管理
//获取考试模式列表
export const getExamModelTypeList = (params) => {
    return axios.get(`${base}/fftmwebapi/examModelType/getExamModelTypeList`, { params: params });
}

//成绩管理
//当前数据列表
export const getExamScoreList = (params) => {
    return axios.get(`${base}/fftmwebapi/score/getExamScoreList`, { params: params });
}
//详情
export const getExamDetailByExamId = (params) => {
    return axios.get(`${base}/fftmwebapi/score/getExamDetailByExamId`, { params: params });
}
//上传视频
export const uploadVideoFile =`${base}/fftmwebapi/videoManage/uploadVideoFile`

//视频管理
//获取当前数据列表
export const getExamIdentifyPointVideoList = (params) => {
    return axios.get(`${base}/fftmwebapi/examIdentifyPointVideo/getExamIdentifyPointVideoList`, { params: params });
}
//新增
export const addExamIdentifyPointVideo = params => {
    return axios.post(`${base}/fftmwebapi/examIdentifyPointVideo/addExamIdentifyPointVideo`, params);
}
//编辑
export const updateExamIdentifyPointVideo = params => {
    return axios.post(`${base}/fftmwebapi/examIdentifyPointVideo/updateExamIdentifyPointVideo`, params);
}

//获取js上传视频参数
export const getVideoUploadParams = (params) => {
    return axios.get(`${base}/fftmwebapi/videoManage/getVideoUploadParams`, { params: params });
}

//新增视频编码
export const addVideoByCode = params => {
    return axios.post(`${base}/fftmwebapi/videoManage/addVideoByCode`,  params );
}

//
export const getWechatLoginUrl = (params) => {
    return axios.get(`${base}/fftmwebapi/login/getWechatLoginUrl`, { params: params });
}

//鉴定点管理 - 品牌列表
//获取职业等级方向列表
export const getOproomBrandList = (params) => {
    return axios.get(`${base}/fftmwebapi/oproomBrand/getOproomBrandList`, { params: params });
}
//新增品牌
export const addOproomBrand = params => {
    return axios.post(`${base}/fftmwebapi/oproomBrand/addOproomBrand`, params);
}
//编辑品牌
export const updateOproomBrand = params => {
    return axios.post(`${base}/fftmwebapi/oproomBrand/updateOproomBrand`, params);
};
//删除品牌
export const deleteOproomBrand = params => {
    return axios.post(`${base}/fftmwebapi/oproomBrand/deleteOproomBrand`, params);
};
